import { AppState } from "../store/definitions";
import { Box } from "@twilio-paste/core/box";
import { Header } from "./Header";
import { NotificationBarItem } from "./NotificationBarItem";
import { WarningIcon } from "@twilio-paste/icons/esm/WarningIcon";
import { useSelector } from "react-redux";

export const ErrorPhase = () => {
  const notifications = useSelector((state: AppState) => state.notifications);

  return (
    <>
      <Header />
      <Box
        padding="space60"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        backgroundColor="colorBackground"
        textAlign="center"
        height="100%"
      >
        <Box marginBottom="space40">
          <WarningIcon
            decorative={false}
            title="Warning"
            size="sizeIcon70"
            color="colorTextError"
          />
        </Box>
        <Box width="100%" paddingX="space40">
          {notifications.map((notification) => (
            <NotificationBarItem key={notification.id} {...notification} />
          ))}
        </Box>
      </Box>
    </>
  );
};
